import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    inlineFormWrapper: {
        marginBottom: theme.spacing(5),
    },
    inlineFormRow: {
        display: "flex",
        alignItems: "flex-end",
        gap: theme.spacing(2),
        width: "100%",
    },
    inlineFormField: {
        flex: 1,
        minWidth: 0,
    },
    inlineFormDatePicker: {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            fontSize: "14px !important",
            height: 41,
        },
    },
    card: {
        marginTop: "24px !important",
    },
    cardContent: {
        padding: "16px !important",
    },
    contentFormTextField: {
        width: "100%",
        height: theme.spacing(10),
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            fontWeight: "400",
            backgroundColor: theme.palette.primary.main,
            "& .MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontWeight: "400",
                padding: `${theme.spacing(2.125)} ${theme.spacing(3.5)} !important`,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
}));
